"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadProgressionByFeedSelector = exports.replayableFailureItemsSelector = exports.lastFileFeedItemEntitySelector = exports.isFetchingFeedItemsSelector = exports.isFetchingFeedItemsByFeedSelector = exports.isEndReachedFeedItemsSelector = exports.isEndReachedFeedItemsByFeedSelector = exports.hasFeedItemsByFeed = exports.getOldestFeedItemsIdToDeleteByLimit = exports.getOldestFeedItemByFeed = exports.getNewestFeedItemByFeed = exports.getLastFileFeedItems = exports.getLastFeedItemPostedByCurrentUserByFeedSelector = exports.getFileUploadProgressionByFeedSelector = exports.getFileUploadProgressionByFeedItemSelector = exports.getFileFeedItemsByFeedSelector = exports.getFeedItems = exports.firstFeedItemByFeedSelector = exports.fileItemsByFeedSelector = exports.feedItemsByFeedSelector = exports.feedItemEntitySelector = exports.feedItemByIdSelector = exports._lastFileFeedItemsSelector = void 0;
var _reselect = require("reselect");
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _sumBy = _interopRequireDefault(require("lodash/sumBy"));
var _selectors = require("../entities/selectors");
var _selectors2 = require("../session/selectors");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ONE_DAY = 1000 * 3600 * 24;
var _getFeedParameter = (_, _feed) => _feed;
var _getFeedItemParameter = (_, _feed, _feedItem) => _feedItem;
var feedItemEntitySelector = state => (0, _selectors.entitiesSelector)(state).feedItems;
exports.feedItemEntitySelector = feedItemEntitySelector;
var feedItemByIdSelector = _feedItem => state => (0, _selectors.entitiesSelector)(state).feedItems[_feedItem];
exports.feedItemByIdSelector = feedItemByIdSelector;
var feedItemsByFeedSelector = state => state.feedItems.itemsByFeed;
exports.feedItemsByFeedSelector = feedItemsByFeedSelector;
var fileItemsByFeedSelector = state => state.feedItems.filesByFeed;
exports.fileItemsByFeedSelector = fileItemsByFeedSelector;
var uploadProgressionByFeedSelector = state => state.feedItems.progressionByFeed;
exports.uploadProgressionByFeedSelector = uploadProgressionByFeedSelector;
var replayableFailureItemsSelector = state => state.feedItems.replayableFailureItems;
exports.replayableFailureItemsSelector = replayableFailureItemsSelector;
var _lastFileFeedItemsSelector = state => state.feedItems._lastFileFeedItems;
exports._lastFileFeedItemsSelector = _lastFileFeedItemsSelector;
var lastFileFeedItemEntitySelector = state => (0, _selectors.entitiesSelector)(state).lastFileFeedItems;
exports.lastFileFeedItemEntitySelector = lastFileFeedItemEntitySelector;
var isFetchingFeedItemsSelector = state => state.feedItems.isFetching;
exports.isFetchingFeedItemsSelector = isFetchingFeedItemsSelector;
var isFetchingFeedItemsByFeedSelector = _feed => state => {
  var _isFetchingFeedItemsS;
  return (_isFetchingFeedItemsS = isFetchingFeedItemsSelector(state)) === null || _isFetchingFeedItemsS === void 0 ? void 0 : _isFetchingFeedItemsS[_feed];
};
exports.isFetchingFeedItemsByFeedSelector = isFetchingFeedItemsByFeedSelector;
var isEndReachedFeedItemsSelector = state => state.feedItems.isEndReached;
exports.isEndReachedFeedItemsSelector = isEndReachedFeedItemsSelector;
var firstFeedItemByFeedSelector = state => state.feedItems.firstItemByFeed;
exports.firstFeedItemByFeedSelector = firstFeedItemByFeedSelector;
var isEndReachedFeedItemsByFeedSelector = _feed => state => {
  var _isEndReachedFeedItem;
  return (_isEndReachedFeedItem = isEndReachedFeedItemsSelector(state)) === null || _isEndReachedFeedItem === void 0 ? void 0 : _isEndReachedFeedItem[_feed];
};
exports.isEndReachedFeedItemsByFeedSelector = isEndReachedFeedItemsByFeedSelector;
var userEntitySelector = state => (0, _selectors.entitiesSelector)(state).users;
var isSameDateGroup = (item1, item2) => {
  if (!item1 || !item2) return false;
  return (new Date(item2.createdAt) - new Date(item1.createdAt)) / (1000 * 60) <= 3;
};
var isSameUser = (item1, item2) => {
  if (!item1 || !item2) return false;
  return (item1 === null || item1 === void 0 ? void 0 : item1._user) === (item2 === null || item2 === void 0 ? void 0 : item2._user);
};
var isSameDay = (date1, date2) => date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
var shouldShowDateSeparator = (item1, item2) => {
  if (!item1 || !item2) return false;
  return !isSameDay(new Date(item1.createdAt), new Date(item2.createdAt));
};
var getLastFileFeedItems = exports.getLastFileFeedItems = (0, _reselect.createSelector)([_lastFileFeedItemsSelector, lastFileFeedItemEntitySelector, userEntitySelector], (_lastFileFeedItems, lastFileFeedItemEntities, userEntities) => {
  if (!(_lastFileFeedItems !== null && _lastFileFeedItems !== void 0 && _lastFileFeedItems.length)) return [];
  return _lastFileFeedItems.reduce((acc, _feedItem) => {
    var item = lastFileFeedItemEntities[_feedItem];
    if (item) {
      item.user = userEntities[item._user];
      acc.push(item);
    }
    return acc;
  }, []);
});
var getFileFeedItemsByFeedSelector = exports.getFileFeedItemsByFeedSelector = (0, _reselect.createSelector)([_getFeedParameter, fileItemsByFeedSelector, feedItemEntitySelector], (_feed, filesByFeed, fileFeedItemEntities) => {
  var _fileFeedItems = filesByFeed[_feed];
  if (!(_fileFeedItems !== null && _fileFeedItems !== void 0 && _fileFeedItems.length)) return [];
  return _fileFeedItems.reduce((acc, _feedItem) => {
    var item = fileFeedItemEntities[_feedItem];
    if (item) {
      acc.push(item);
    }
    return acc;
  }, []);
});
var getFileUploadProgressionByFeedSelector = exports.getFileUploadProgressionByFeedSelector = (0, _reselect.createSelector)([_getFeedParameter, uploadProgressionByFeedSelector], (_feed, progressionByFeed) => {
  var items = Object.values(progressionByFeed[_feed] || {});
  var loaded = (0, _sumBy.default)(items, 'loaded');
  var total = (0, _sumBy.default)(items, 'total');
  return Math.round(loaded * 100 / total);
});
var getFileUploadProgressionByFeedItemSelector = exports.getFileUploadProgressionByFeedItemSelector = (0, _reselect.createSelector)([_getFeedParameter, _getFeedItemParameter, uploadProgressionByFeedSelector], (_feed, _feedItem, progressionByFeed) => {
  var _progressionByFeed$_f;
  var {
    loaded,
    total
  } = ((_progressionByFeed$_f = progressionByFeed[_feed]) === null || _progressionByFeed$_f === void 0 ? void 0 : _progressionByFeed$_f[_feedItem]) || {};
  return Math.round(loaded * 100 / total);
});
var getLastFeedItemPostedByCurrentUserByFeedSelector = exports.getLastFeedItemPostedByCurrentUserByFeedSelector = (0, _reselect.createSelector)([_getFeedParameter, _selectors2.getUserId, feedItemsByFeedSelector, feedItemEntitySelector], (_selectedFeed, _currentUser, feedItemsByFeed, feedItemEntities) => {
  var _feedItemsByFeed$_sel;
  var _feedItem = (_feedItemsByFeed$_sel = feedItemsByFeed[_selectedFeed]) === null || _feedItemsByFeed$_sel === void 0 ? void 0 : _feedItemsByFeed$_sel.find(_feedItem => {
    var _feedItemEntities$_fe;
    return ((_feedItemEntities$_fe = feedItemEntities[_feedItem]) === null || _feedItemEntities$_fe === void 0 ? void 0 : _feedItemEntities$_fe._user) === _currentUser;
  });
  return _feedItem ? feedItemEntities[_feedItem] : undefined;
});
var getFeedItems = exports.getFeedItems = (0, _reselect.createSelector)([_getFeedParameter, feedItemsByFeedSelector, feedItemEntitySelector, _selectors2.getUserId], (_selectedFeed, _feedItemsByFeed, feedItemEntities, _currentUser) => {
  var _config$feed, _feedItems, _feedItems$reverse;
  var feedItems = [];
  if (_feedItemsByFeed !== null && _feedItemsByFeed !== void 0 && _feedItemsByFeed[_selectedFeed]) {
    _feedItemsByFeed[_selectedFeed].forEach(id => {
      if (feedItemEntities[id]) {
        feedItems.push(feedItemEntities[id]);
      }
    });
  }
  feedItems = feedItems.sort((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? -1 : 1);
  var responseSent = false;
  var unreadFlagSet = false;
  feedItems.forEach((feedItem, index) => {
    // usefull to hide the unread flag if we respond
    if (feedItem._user === _currentUser) {
      feedItem.isMe = true;
      responseSent = true;
    }
    var nextFeedItem = feedItems[index + 1] || {};
    var showTimeSeparator = shouldShowDateSeparator(feedItem, nextFeedItem);
    var isDateGrouped = !showTimeSeparator && isSameDateGroup(feedItem, nextFeedItem);
    var isSameUserValue = isSameUser(feedItem, nextFeedItem);
    var isSpecialItem = !!feedItem.specialType || !!nextFeedItem.specialType;
    var hasUnreadFlag = !unreadFlagSet && !responseSent && feedItem.isUnread && !nextFeedItem.isUnread;
    var isGrouped = isSameUserValue && isDateGrouped && !isSpecialItem && !hasUnreadFlag;
    var relative = showTimeSeparator ? Math.abs(new Date(feedItem.createdAt) - new Date()) / ONE_DAY <= 3 : false;
    feedItem.hasUnreadFlag = hasUnreadFlag;
    feedItem.hideFullname = isGrouped;
    feedItem.hideAvatar = isGrouped;
    feedItem.showTimeSeparator = showTimeSeparator;
    feedItem.relative = relative;
    if (hasUnreadFlag) {
      feedItem.unreadCount = index + 1;
      unreadFlagSet = true;
    }
  });
  return (_config$feed = _config.default.feed) !== null && _config$feed !== void 0 && _config$feed.reverseFeedItems ? (_feedItems = feedItems) === null || _feedItems === void 0 || (_feedItems$reverse = _feedItems.reverse) === null || _feedItems$reverse === void 0 ? void 0 : _feedItems$reverse.call(_feedItems) : feedItems;
});

// deprecated => should be called directly instead of function wrapping
var hasFeedItemsByFeed = () => (0, _reselect.createSelector)([_getFeedParameter, feedItemsByFeedSelector], (_selectedFeed, _feedItemsByFeed) => {
  var _feedItemsByFeed$_sel2;
  return !!(_feedItemsByFeed !== null && _feedItemsByFeed !== void 0 && (_feedItemsByFeed$_sel2 = _feedItemsByFeed[_selectedFeed]) !== null && _feedItemsByFeed$_sel2 !== void 0 && _feedItemsByFeed$_sel2.length);
});
exports.hasFeedItemsByFeed = hasFeedItemsByFeed;
var getOldestFeedItemByFeed = exports.getOldestFeedItemByFeed = (0, _reselect.createSelector)([_getFeedParameter, feedItemsByFeedSelector, feedItemEntitySelector], (_selectedFeed, _feedItemsByFeed, feedItemEntities) => {
  var feedItems = [];
  if (_feedItemsByFeed !== null && _feedItemsByFeed !== void 0 && _feedItemsByFeed[_selectedFeed]) {
    _feedItemsByFeed[_selectedFeed].forEach(id => {
      if (feedItemEntities[id]) {
        feedItems.push(feedItemEntities[id]);
      }
    });
  }
  feedItems = feedItems.sort((a, b) => new Date(a.createdAt) > new Date(b.createdAt) ? -1 : 1);
  if (feedItems.length) {
    var feedItem = feedItems[feedItems.length - 1];
    return feedItemEntities[feedItem.id];
  }
  return undefined;
});
var getNewestFeedItemByFeed = exports.getNewestFeedItemByFeed = (0, _reselect.createSelector)([_getFeedParameter, feedItemsByFeedSelector, feedItemEntitySelector], (_selectedFeed, _feedItemsByFeed, feedItemEntities) => {
  var feedItems = [];
  if (_feedItemsByFeed !== null && _feedItemsByFeed !== void 0 && _feedItemsByFeed[_selectedFeed]) {
    feedItems = _feedItemsByFeed[_selectedFeed].reduce((acc, id) => {
      if (feedItemEntities[id] && !feedItemEntities[id].isSending && !feedItemEntities[id].isError) {
        acc.push({
          // Only push the values we need to search for the oldest feedItem
          id: feedItemEntities[id].id,
          createdAt: feedItemEntities[id].createdAt
        });
      }
      return acc;
    }, []);
  }

  // Retrieve the oldest feedItem that is not currently being sent
  var feedItem = feedItems.reduce((acc, value) => new Date(acc.createdAt) > new Date(value.createdAt) ? acc : value, {
    id: 0,
    createdAt: 0
  } // Initial value
  );

  if (feedItem.id !== 0) {
    // Check if it's not the initial value that was returned by the reduce
    return feedItemEntities[feedItem.id];
  }
  return undefined;
});
var getOldestFeedItemsIdToDeleteByLimit = limit => (0, _reselect.createSelector)([feedItemEntitySelector], feedItemEntities => {
  var feedItemsSorted = (0, _sortBy.default)(feedItemEntities, ['createdAt']);
  var feedItemsTodelete = feedItemsSorted.slice(0, -1 * limit);
  return feedItemsTodelete.map(f => f.id);
});
exports.getOldestFeedItemsIdToDeleteByLimit = getOldestFeedItemsIdToDeleteByLimit;